import { useCallback } from 'react'
import { useAppSelector } from 'store/hooks'
import {
  getCompanyVerified,
  getSelectedCompany,
  getCompanyAccessToSellWine,
  getCompanyAccessToRetail,
} from 'store/me'
import { PROHIBITED } from 'utils/consts/companyStatus'
import useUserRole from 'utils/user/useUserRole'

interface MenuItem {
  id: string
  forVerifiedOnly?: boolean
}

export const useMenuItemDisabled = () => {
  const selectedCompany = useAppSelector(getSelectedCompany)
  const isVerified = useAppSelector(getCompanyVerified)
  const companyHasAccessToSellWine = useAppSelector(getCompanyAccessToSellWine)
  const companyHasAccessToRetail = useAppSelector(getCompanyAccessToRetail)
  const isProhibited = selectedCompany?.verificationStatus?.code === PROHIBITED
  const { isPerson } = useUserRole()

  const isItemDisabled = useCallback(
    (item: MenuItem): boolean => {
      if (item.id === 'sell-wine') {
        return !companyHasAccessToSellWine || isProhibited
      }
      if (item.id === 'buy-wine') {
        return isProhibited
      }
      if (item.id === 'retail') {
        return isPerson && (!companyHasAccessToRetail || isProhibited)
      }

      return !isVerified && (item.forVerifiedOnly ?? false)
    },
    [isVerified, companyHasAccessToSellWine, companyHasAccessToRetail]
  )

  return isItemDisabled
}
